module.exports = __webpack_public_path__ + "static/media/sistemaPegar8.433f362b.jpg";